import React from 'react';
import { 
  Visibility, 
  VisibilityOff
} from '@mui/icons-material';

import BaseButton from './BaseButton';

interface Props extends React.ComponentPropsWithoutRef<'div'> {
  disabled?: boolean;
  label?: string;
  label_separate?: boolean;
  no_fab?: boolean;
  fab?: boolean;
  link_url?: string;
  log_it?: boolean;
  closed?: boolean;
  onClick: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement> | undefined) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>) => void;
}

export default function EyeButton(props: Props) {
  const pass_along_props = {...props};
  delete pass_along_props.closed;
  
  return (
    <BaseButton
      icon={ props.closed ? <VisibilityOff /> : <Visibility /> }
      {...pass_along_props}
    />
  );
}
